import { ApolloClient, createHttpLink, InMemoryCache, ServerError } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import { onError } from "@apollo/client/link/error"
import { API_URL } from "env"
import { enqueueSnackbar } from "notistack"
import { signOut } from "reducers/profileSlice"
import { store } from "reducers/store"

const httpLink = createHttpLink({
  uri: `${API_URL}/graphql`,
})

const authLink = setContext((_, { headers }) => {
  const { accessToken, isLoggedIn } = store.getState().profile
  return {
    headers: {
      ...headers,
      authorization: isLoggedIn ? `Bearer ${accessToken}` : undefined,
    },
  }
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  graphQLErrors?.forEach((error) => {
    const extension = error.extensions as { code: string }
    enqueueSnackbar(extension.code, { variant: "error" })
  })
  if ((networkError as ServerError)?.statusCode === 401) {
    enqueueSnackbar("Phiên đăng nhập hết hạn", { key: "SESSION_EXPIRED", variant: "info" })
    store.dispatch(signOut())
  }
})

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorLink.concat(authLink).concat(httpLink),
  uri: `${API_URL}/graphql`,
})
